module.exports = __webpack_public_path__ + "img/wind.25357913.svg";